import InfluencerJobs from '@/Component/Influencer/InfluencerJobs';

const JobsPage = () => {
    return <InfluencerJobs />;
};

export default JobsPage;
